/*DEV 02/12/21*/
/*Register*/
const create_customer_form = document.querySelector('#create_customer');
if(create_customer_form){
	create_customer_form.addEventListener('submit', registerSubmit);
}
function registerSubmit(event) {
  	event.preventDefault();
  	var values = [];
    $.each($('#create_customer').serializeArray(), function(i, field) {
    	var item = { }; 
    	item["name"] = field.name;
    	item["value"] = field.value;
     	values.push(item);
    });
  	ajaxSendInfo('create_customer',values);
}

/*ResetPw*/
const pw_input = document.querySelector('#customer_password');
const pw_input2 = document.querySelector('#customer_password_confirmation');
const btnResetPw = document.querySelector('#btnResetPw');
if(pw_input && pw_input2 && btnResetPw){
  var formsCollection = document.getElementsByTagName("form");
  for(var i=0;i<formsCollection.length;i++)
  {
    var action_form = formsCollection[i].action;
      if(action_form.includes('account/reset')){
        formsCollection[i].setAttribute("id", "account_reset_password");
        const account_reset_password_form = document.querySelector('#account_reset_password');
     	account_reset_password_form.addEventListener('submit', resetPwSubmit);
      }
  }
}
function resetPwSubmit(event) {
  	var values = [];
    $.each($('#account_reset_password').serializeArray(), function(i, field) {
    	var item = { }; 
    	item["name"] = field.name;
    	item["value"] = field.value;      
     	values.push(item);
    });
  	ajaxSendInfo('reset_customer_password',values);
}

/*ActivateAccount*/
const btnActivateAcc = document.querySelector('#btnActivateAcc');
if(pw_input && pw_input2 && btnActivateAcc){
  var formsCollection = document.getElementsByTagName("form");
  for(var i=0;i<formsCollection.length;i++)
  {
    var action_form = formsCollection[i].action;
      if(action_form.includes('account/activate')){
        formsCollection[i].setAttribute("id", "activate_customer_password");
        const activate_customer_password_form = document.querySelector('#activate_customer_password');
     	activate_customer_password_form.addEventListener('submit', activateAccSubmit);
      }
  }
}
function activateAccSubmit(event) {
  	var values = [];
    $.each($('#activate_customer_password').serializeArray(), function(i, field) {
    	var item = { }; 
    	item["name"] = field.name;
    	item["value"] = field.value;
     	values.push(item);
    });
  	ajaxSendInfo('activate_customer_password',values);
}


/*--Ajx-sendinfo--*/
function ajaxSendInfo(method,values)
{
  	var dataFields = {
      app_token: "vJelGFto2JCKZ1fAOvlPna2BluCKZ23C0JAEBVmLHRoQsWMzPY2OIvD",
      action: method,
      fields: values
    };
  	//console.log("AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA"+method);
  	
 	// AJAX 
    $.ajax({
      type: "POST",
      url: "https://community.oppostore.it/api/shopify/update-customer",
      data: dataFields,
      success: function (data) {
        if (data.response.success) {
          //  alert("ajaxSendInfo SUCCESS");
          //console.log("SUCCESSSUCCESSSUCCESSSUCCESSSUCCESSSUCCESS");
        } else {
          //console.log("KKKKKKK ----------"+data.response.error_code);
        }
      },
      error: function (xhr, status, error) {
        // Err
        var err = eval("(" + xhr.responseText + ")");
  		//alert(err.Message);
        //console.log("WWWWWWWW ----------"+err);
        return;
      }
    }); 
}


/*Register page*/
// Show recover pw on account/register page
const recover_password =  document.querySelector('#recover-password');
const recover_email =  document.querySelector('#recover_email');
if(recover_password && recover_email){
  const urlParams = window.location.search;
  if(urlParams.includes('recover-pw')){
  	showRecoverPasswordForm();
  }
}